import { makeStyles } from '@material-ui/core'

export default makeStyles({
  root: {
    height: '500px',
  },
})
